import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import sequenceAction from 'redux-sequence-action';
import rootReducer from '../reducers';
import api from '../middleware/api';

export default function configureStore(initialState) {
    return createStore(
        rootReducer,
        initialState,
        applyMiddleware(sequenceAction, thunk, api)
    );
}



// WEBPACK FOOTER //
// ./src/js/store/configureStore.prod.js